package at.apa.statistictracker.configuration

import com.squareup.sqldelight.db.SqlDriver
import kotlin.js.JsExport

@JsExport
interface Configuration {

    /**
     * Defines the endpoint config (see [EndpointConfig])
     */
    val endpointConfig: EndpointConfig

    /**
     * Defines the initial wait time in seconds for the first statistic event dispatch after starting the tracker.
     * The value must be greater than or equal to 0.
     */
    val initialDispatchDelay: Int

    /**
     * Defines the wait time in seconds for the next statistic events dispatch after statistic events have been sent to the server.
     * The value must be greater than or equal to 10.
     */
    val dispatchInterval: Int

    /**
     * Defines if the the library is debuggable or not.
     * If true it is possible to:
     *   - see log messages
     */
    val debuggable: Boolean

    /**
     * Defines how many statistic events are sent at once (in one POST request) to the backend.
     * The value must be greater than 0 and smaller than or equal to 100.
     */
    val dispatchBundleSize: Int

    /**
     * Defines the sql driver for the respective platform.
     */
    val sqlDriver: SqlDriver
}


@JsExport
data class EndpointConfig(
    val apiBaseUrl: String,
    val apiKey: String
)